<template>
  <div>
    <PageAllow
      controller="ReturnOrders"
      :action="isNew ? 'add' : isView ? 'view' : mode"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t(isNew ? "CRUD.newInfo" : "CRUD.info", [$t("ReturnOrder.ObjectName")]) }}
              <v-chip
                v-if="order.cancel_flg || order.error_flg"
                small
                label
                outlined
                class="ms-4 mt-1"
                color="danger"
              >
                {{ order.cancel_flg ? $t("CRUD.cancelled") : $t("Order.redeliverError") }}
              </v-chip>
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="order.status | returnOrderStatusColor"
                :text-color="order.status | returnOrderStatusTextColor"
                >{{ order.status | returnOrderStatusText }}
              </v-chip>
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="bill.pay_flg | billPayFlgsColor"
                :text-color="bill.pay_flg | billPayFlgsTextColor"
                >{{ bill.pay_flg | billPayFlgsText }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  v-if="!isNew && savable"
                  small
                  dark
                  outlined
                  color="secondary"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="mode = 'view'"
                >
                  <v-icon x-small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToView") }}
                </v-btn>
                <v-btn
                  v-if="isNew && $permission.permissionAllow('Orders', 'add')"
                  small
                  :disabled="!forOrderFlg"
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("ReturnOrder.actions.submitOrder") }}
                </v-btn>
              </v-sheet>
              <OrderActions
                v-if="isView"
                :order="order"
                detail-mode
              />
            </v-card-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnOrder.Fields.order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ order.order_code }}
                </v-card>
              </v-col>
              <v-col cols="12" md="8" v-if="!isNew && forOrderFlg">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnOrder.Fields.for_order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ order.for_order ? order.for_order.order_code : "" }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnOrder.Fields.order") }}{{ $t("Global.colon") }}
                  </span>
                  <span class="secondary--text">
                    {{ forOrder ? forOrder.order_code : "" }}
                  <v-btn
                    v-if="isNew"
                    :disabled="!shop || !shop.id"
                    small
                    dark
                    text
                    color="action"

                    @click.stop="selectOrderDialog = true"
                  >
                    <v-icon x-small class="pe-1">fa-store</v-icon>
                    {{ $t("CRUD.rechooseInfo", [$t("Order.title")]) }}
                  </v-btn>
                   <v-btn
                    v-if="forOrderFlg"
                    fab
                    icon
                    x-small
                    text
                    @click.stop="forOrderFlg = false;"
                   >
                     <v-icon x-small class="pe-1">fa-times</v-icon>
                   </v-btn>
                  </span>
                </v-card>
              </v-col>
              <v-col v-if="!isNew" cols="12" md="4" class="d-none d-md-inline">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnOrder.Fields.creater")}}{{ $t("Global.colon") }}
                  </span>
                  {{ order.creater_name }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnOrder.Fields.created_time") }}{{ $t("Global.colon") }}
                  </span>
                  {{ order.created | formatTime }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnOrder.Fields.actual_time") }}{{ $t("Global.colon") }}
                  </span>
                  <SearcherDatetime
                    class="my-n2"
                    v-if="savable"
                    v-model="order.actual_date"
                    type="datetime"
                    single-line
                    dense
                    hide-details
                  />
                  <span v-else>
                    {{ order.actual_date | formatTime }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" :md="isNew ? '4' : '12'">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Shop.Fields.shop_code", [$consts.shopName()]) }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="isNew">
                    {{ accountUser ? accountUser.shop_code : "" }}
                  </span>
                  <span v-else>
                    [{{ accountUser ? accountUser.shop_code : "" }}]
                    {{ accountUser ? accountUser.shop_name : "" }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="12" v-if="isNew">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Shop.Fields.shop_name", [$consts.shopName()]) }}{{ $t("Global.colon") }}
                  </span>
                  {{ accountUser ? accountUser.shop_name : "" }}
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{
                      $t("ReturnOrder.Fields.shop_address", [
                        $consts.shopName(),
                      ])
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ shop.address }}
                  <v-icon small class="ps-2 action--text d-none">
                    fa-map-marked-alt
                  </v-icon>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnOrder.Fields.memo") }}{{ $t("Global.colon") }}
                  </span>
                  <v-text-field
                    v-if="savable"
                    v-model="order.memo"
                    single-line
                    dense
                    hide-details
                    class="d-inline mt-0 mb-n1"
                  />
                  <span v-else>
                    {{ order.memo }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnOrder.Fields.remark", [$consts.shopName()])
                    }}{{ $t("Global.colon") }}
                  </span>
                  <v-text-field
                    v-if="savable"
                    v-model="order.remark"
                    single-line
                    dense
                    hide-details
                    class="d-inline mt-0 mb-n1"
                  />
                  <span v-else>
                    {{ order.remark }}
                  </span>
                </v-card>
              </v-col>
              <!-- 退货类型 -->
              <v-col cols="12" sm="12" md="12" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text pt-1">
                    {{ $t("ReturnOrder.Fields.type") }}{{ $t("Global.colon") }}
                  </span>
                  <v-radio-group
                    row
                    v-model="order.return_type"
                    v-if="savable"
                    class="mt-0"
                    dense
                    hide-details
                  >
                    <v-radio
                      :label="$t('ReturnOrder.Type.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('ReturnOrder.Type.off')"
                      :key="2"
                      :value="2"
                    />
                  </v-radio-group>
                  <span v-else>
                    {{
                      order.return_type == 1
                        ? $t("ReturnOrder.Type.on")
                        : order.return_type == 2
                        ? $t("ReturnOrder.Type.off")
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-card
                  class="pa-2 text-no-wrap d-flex overflow-auto"
                  outlined
                  tile
                >
                  <span class="secondary--text">
                    {{ $t("ReturnOrder.Fields.attachments")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <!-- 上传图片集 -->
                  <span class="ml-4">
                    <v-card
                      height="160"
                      width="240"
                      v-if="album && album.length > 0"
                    >
                      <v-carousel
                        hide-delimiters
                        cycle
                        height="160"
                        width="240"
                      >
                        <v-carousel-item
                          v-for="(item, i) in album"
                          :key="i"
                          :src="item"
                          @click.stop="$showFullscreenImages(album, i)"
                        >
                          <v-tooltip right v-if="isNew && item">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="secondary"
                                class="pa-2 float-right"
                                @click.stop="removeFromImages(i)"
                              >
                                fa-times
                              </v-icon>
                            </template>
                            <span> {{ $t("Material.delImg") }}</span>
                          </v-tooltip>
                        </v-carousel-item>
                      </v-carousel>
                    </v-card>
                    <v-file-input
                      ref="imgs_file"
                      v-show="savable && order.relation_order_id == null"
                      show-size
                      counter
                      small-chips
                      multiple
                      suffix
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('Material.imgsPlaceholder')"
                      :hint="$t('Material.imgsHint')"
                      :rules="imgsRules"
                      v-model="imgs_file"
                    >
                    </v-file-input>
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="!isNew">
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("Order.actions.activities") }}
              </v-tab>
              <v-tab
                @click.stop="
                  tab = 1;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
                v-if="$permission.permissionAllow('ReturnOrders', 'relations')"
              >
                {{ $t("Order.actions.relations") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="order_activities"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="relationsHeaders"
                    :items="order_relations"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>

                    <template v-slot:item.identify_name="{ item }">
                      <span v-if="!item.index" class="text-no-wrap">
                        {{ item.identify_name }}
                      </span>
                    </template>
                    <template v-slot:item.identify_code="{ item }">
                      <span class="text-no-wrap">
                        {{ item.identify_code }}
                      </span>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <div v-if="item.status >= 0" class="text-no-wrap">
                        <v-chip
                          v-if="item.identify == 'return-orders'"
                          small
                          label
                          :color="item.status | returnOrderStatusColor"
                          :text-color="item.status | returnOrderStatusTextColor"
                          >{{ item.status | returnOrderStatusText }}
                        </v-chip>
                        <v-chip
                          v-if="item.identify == 'stock-orders-in'"
                          small
                          label
                          :color="item.status | stockOrderINStatusColor"
                          :text-color="
                            item.status | stockOrderINStatusTextColor
                          "
                          >{{ item.status | stockOrderINStatusText }}
                        </v-chip>
                        <v-chip
                          v-if="item.identify == 'receipts'"
                          small
                          label
                          :color="item.pay_flg | billPayFlgsColor"
                          :text-color="item.pay_flg | billPayFlgsTextColor"
                          >{{ item.pay_flg | billPayFlgsText }}
                        </v-chip>
                        <v-chip
                          v-if="item.identify == 'receipts'"
                          small
                          label
                          class="ms-1"
                          :color="item.status | billStatusColor"
                          :text-color="item.status | billStatusTextColor"
                          >{{ item.status | billStatusText }}
                        </v-chip>
                        <v-chip
                          v-if="item.identify == 'qacenter/question-detail'"
                          small
                          label
                          class="ms-1"
                          :color="item.status | qacenterColor"
                          :text-color="item.status | qacenterTextColor"
                          >{{ item.status | qacenterText }}
                        </v-chip>
                        <v-chip
                          v-if="item.identify == 'orders'"
                          small
                          label
                          class="ms-1"
                          :color="item.status | orderStatusColor"
                          :text-color="item.status | orderStatusTextColor"
                          >{{ item.status | orderStatusText }}
                        </v-chip>
                        <v-chip
                          v-if="item.identify == 'stock-order-out'"
                          small
                          label
                          class="ms-1"
                          :color="item.status | stockOrderOUTStatusColor"
                          :text-color="
                            item.status | stockOrderOUTStatusTextColor
                          "
                          >{{ item.status | stockOrderOUTStatusText }}
                        </v-chip>
                      </div>
                    </template>
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                    <template v-slot:item.creater_name="{ item }">
                      <span
                        class="text-no-wrap"
                        v-if="
                          item.shop_user &&
                          item.identify == 'qacenter/question-detail'
                        "
                      >
                        {{ item.shop_user.name }}
                      </span>
                      <span v-else>
                        {{ item.creater_name }}
                      </span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        v-if="
                          item.identify != 'return-orders' &&
                          $permission.permissionAllow(item.controller, 'view')
                        "
                        small
                        outlined
                        color="info"
                        class="px-2 me-2"
                        :href="'/#/' + item.identify + '/' + item.id"
                      >
                        <v-icon x-small class="pe-1">fa-align-left</v-icon>
                        {{ $t("Opt.details") }}
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-card class="px-4 mt-4">
        <v-toolbar flat class="transparent-background-color">
          <v-row no-gutters align="center">
            <v-toolbar-title class="ms-n2">
              {{ $t("CRUD.details", [$t("ReturnOrder.ObjectName")]) }}
            </v-toolbar-title>
            <v-spacer />
            <span
              v-if="savable"
              class="secondary--text text-subtitle-2 font-weight-bold"
            >
              {{ $t("ReturnOrder.Fields.price_in_edit") }}{{ $t("Global.colon") }}
            </span>
            <span
              v-if="savable"
              class="accent--text text-subtitle-2 font-weight-bold"
            >
              {{ $t("Global.money") }}{{ price_fix | formatMoney }}
            </span>
          </v-row>
        </v-toolbar>
        <v-divider />
        <ValidationObserver ref="observer">
          <v-data-table
            id="order_details_table"
            :headers="detailsHeaders"
            :items="orderDetails"
            :search="filter"
            multi-sort
            disable-pagination
            hide-default-footer
            :no-data-text="$t('Order.DetailNoData')"
            class="pb-2"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <v-row no-gutters class="me-n3">
                  <span class="caption secondary--text pt-2">
                    {{
                      $t(
                        "$vuetify.dataFooter.pageText",
                        order_details
                          ? [
                              order_details.length > 0 ? 1 : 0,
                              order_details.length,
                              order_details.length,
                            ]
                          : [0, 0, 0]
                      )
                    }}
                  </span>
                  <v-row no-gutters>
                    <v-spacer />
                    <v-col cols="12" sm="9" md="8">
                      <v-text-field
                        v-model="filter"
                        clearable
                        hide-details
                        :label="$t('Search.filter')"
                      />
                    </v-col>
                  </v-row>
                </v-row>
              </v-toolbar>
            </template>

            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <template v-slot:item.category_name="{ item }">
                <span class="text-no-wrap">
                  <v-icon x-small>
                    {{
                      item.combineFlg
                        ? "fa-box"
                        : item.hide_flg
                        ? "fa-eye-slash"
                        : "fa-eye"
                    }}
                  </v-icon>
                  {{
                    item.combineFlg
                      ? $t("Material.Fields.combine_material")
                      : item.category_name
                  }}
                </span>
            </template>
            <template v-slot:item.Description="{ item }">
              <a
                v-if="item.combineFlg"
                class="text-no-wrap"
                :class="item.error_flg ? 'red--text' : ''"
              >
                {{ item.ruler_name }}
              </a>
              <a
                v-else
                class="text-no-wrap"
                :class="item.error_flg ? 'red--text' : ''"
                @click.stop="
                  dialogMaterialID = item.new
                    ? item.material.id
                    : item.material_id
                "
              >
                {{ item.Description }}
              </a>
            </template>
            <template v-slot:item.apply_num="{ item }">
              <ValidationProvider
                v-if="forOrderFlg"
                v-slot="{ errors }"
                :rules="{ max_value: { max: item.refundable_num } }"
              >
                <NumberInput
                  v-if="isNew && item.new"
                  v-model="item.apply_num"
                  :error-messages="errors"
                  dense
                />
                <span v-else>
                  {{ item.apply_num | formatTwoDot }}
                </span>
              </ValidationProvider>
              <span v-else>
                <NumberInput
                  v-if="isNew && item.new"
                  v-model="item.apply_num"
                  dense
                />
                <span v-else>
                  {{ item.apply_num | formatTwoDot }}
                </span>
              </span>
            </template>
            <template v-slot:item.confirm_num="{ item }">
              <NumberInput
                v-if="mode == 'confirm' || mode == 'edit'"
                v-model="item.confirm_num"
                :disabled="order.origin_flg == '601' && order.ext_code != ''"
                dense
              />
              <span v-else>
                {{ item.confirm_num | formatTwoDot }}
              </span>
            </template>
            <template v-slot:item.price="{ item }">
              <v-text-field
                v-if="savable && !item.combineFlg"
                v-model="item.price"
                :placeholder="
                  $numberFormatter.formatTwoDot(item.org_price, 2) + ''
                "
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.price =
                    item.price == ''
                      ? item.org_price
                      : $numberFormatter.moneyFormat(item.price)
                "
                style="max-width: 80px; margin-left: auto"
              />
              <span v-else>
                {{ $t("Global.money") }}{{ item.price | moneyFormat }}
              </span>
            </template>
            <template v-slot:item.sum="{ item }">
              {{ $t("Global.money") }}{{ item.sum | moneyFormat }}
            </template>
            <template v-slot:item.production_date="{ item }">
              <span v-if="!item.combineFlg">
                <SearcherDatetime
                  v-if="savable"
                  v-model="item.production_date"
                  type="date"
                  single-line
                  dense
                  hide-details
                  hide-icon
                  :required="
                    (item.material && Number(item.material.bestbefore) > 0) ||
                    accountSettings.material_force_bestbefore == 1
                  "
                />
                <span v-else>
                  {{ item.production_date | formatDate }}
                </span>
              </span>
            </template>
            <template v-slot:item.expired_date="{ item }">
              <span v-if="!item.combineFlg">
                <SearcherDatetime
                  v-if="savable"
                  v-model="item.expired_date"
                  type="date"
                  single-line
                  dense
                  hide-details
                  hide-icon
                  :required="
                    (item.material && Number(item.material.bestbefore) > 0) ||
                    accountSettings.material_force_bestbefore == 1
                  "
                />
                <span v-else>
                  {{ item.expired_date | formatDate }}
                </span>
              </span>
            </template>
            <template v-slot:item.memo="{ item }">
              <v-text-field
                v-if="savable"
                v-model="item.memo"
                single-line
                dense
                hide-details
                style="max-width: 120px"
              >
                <template v-slot:append>
                  <v-icon
                    x-small
                    @click.stop="
                      detail_memo_item = item;
                      memo_dialog = true;
                    "
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-edit
                  </v-icon>
                </template>
              </v-text-field>
              <span v-else>
                {{ item.memo }}
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="item.new"
                small
                text
                class="danger--text pa-0"
                @click.stop="
                  order_details.splice(
                    order_details.findIndex((detail) =>
                      item.id
                        ? item.id == detail.id
                        : item.material_id == detail.material_id &&
                          (item.auto_flg
                            ? item.auto_flg == detail.auto_flg
                            : detail.auto_flg == 0)
                    ),
                    1
                  )
                "
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.attachments="{ item }">
              <a
                v-if="item.img && item.img.length"
                class="text-no-wrap"
                @click.stop="
                  currentItem = item;
                  dialogAttachments = true;
                "
              >
                {{ $t("ReturnOrder.DetailFields.attachments") }}
              </a>
            </template>
          </v-data-table>
        </ValidationObserver>
      </v-card>
    </v-sheet>
    <v-dialog v-model="memo_dialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span
            class="red--text d-inline-block text-truncate"
            style="max-width: 360px"
          >
            {{
              $t("Material.materialNameWithCode", [
                detail_memo_item.material_code,
                detail_memo_item.material_name,
              ])
            }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memo_dialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
            v-model="detail_memo_item.memo"
            outlined
            :label="$t('Order.DetailFields.memo')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memo_dialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAttachments" max-width="600px">
      <v-card>
        <v-card-title class="mx-3">
          <span class="d-inline-block text-truncate" style="max-width: 360px">
            {{ $t("ReturnOrder.DetailFields.attachments") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="dialogAttachments = false"
              >
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text
          class="px-4 pt-8 d-flex justify-space-around"
          v-if="currentItem.img && currentItem.img.length"
        >
          <v-img
            height="120"
            max-width="180"
            v-for="(item, i) in currentItem.img"
            :key="i"
            :src="item"
            @click.stop="$showFullscreenImages([item])"
            class="d-inline-block"
          >
          </v-img>
        </v-card-text>
        <v-card-text v-else class="pa-8 text-center subtitle-1">
          {{ $t("ReturnOrder.DetailFields.attachmentsNull") }}
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="dialogAttachments = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MaterialDialog v-model="dialogMaterialID" />
    <DialogOrder
      v-model="selectOrderDialog"
      isReturn
      :shopId="shop.id"
      @confirm="selectOrder = $event"
      isActivity
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import OrderActions from "./plugins/Actions";
import DialogOrder from "./plugins/DialogOrder";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import NumberInput from "@/components/plugins/NumberInput";
import MaterialDialog from "@/components/materials/plugins/Dialog";
import ReturnOrders from "@/api/return_orders";
import Materials from "@/api/materials";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Files from "@/api/files";
import Orders from "@/api/orders";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    OrderActions,
    SearcherDatetime,
    NumberInput,
    MaterialDialog,
    ValidationObserver,
    ValidationProvider,
    DialogOrder,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return (this.mode == "new" || this.mode == "edit");
    },
    isNew() {
      return this.mode == "new";
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.returnOrderManagement"),
          disabled: false,
          replace: true,
          href: "/return-orders",
        },
        {
          text:
            this.mode == "confirm"
              ? i18n.t("Nav.returnOrderConfirm")
              : this.mode == "approve"
              ? i18n.t("Nav.returnOrderApprove")
              : this.isNew
              ? i18n.t("Nav.returnOrderNew")
              : i18n.t("Nav.returnOrderDetail"),
          disabled: true,
        },
      ];
      if (!this.isNew) {
        items.push({
          text:
            this.order && this.order.order_code ? this.order.order_code : "",
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("ReturnOrder.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("ReturnOrder.DetailFields.material"),
          align: "start",
          value: "Description",
        },
      ];
      if (this.forOrderFlg && this.isNew) {
        headers.push({
          text: i18n.t("ReturnOrder.DetailFields.refundable_num"),
          align: "center",
          value: "refundable_num",
        });
      }
      headers.push({
        text: i18n.t("ReturnOrder.DetailFields.apply_num"),
        align: "end",
        value: "apply_num",
      });
      if (!this.isNew) {
        headers.push({
          text: i18n.t("ReturnOrder.DetailFields.confirm_num"),
          align: "end",
          value: "confirm_num",
        });
      }
      headers.push({
        text: i18n.t("ReturnOrder.DetailFields.unit"),
        align: "center",
        value: "unit",
      });
      if (this.forOrderFlg) {
        headers.push({
          text: i18n.t("ReturnOrder.DetailFields.org_price"),
          align: "center",
          value: "org_price",
        });
      }
      headers.push({
        text: i18n.t("ReturnOrder.DetailFields.price"),
        align: "center",
        value: "price",
      });
      headers.push({
        text: i18n.t("ReturnOrder.DetailFields.sum"),
        align: "end",
        value: "sum",
      });
      if (this.accountSettings && this.accountSettings.product_date_setting) {
        headers.push({
          text: i18n.t("ReturnOrder.DetailFields.production_date"),
          align: "start",
          value: "production_date",
          width: 136,
        });
        headers.push({
          text: i18n.t("ReturnOrder.DetailFields.expired_date"),
          align: "start",
          value: "expired_date",
          width: 136,
        });
      }
      if (this.accountSettings && this.accountSettings.order_detail_memo)
        headers.push({
          text: i18n.t("ReturnOrder.DetailFields.memo"),
          align: "start",
          sortable: false,
          value: "memo",
        });
      if (!this.isView)
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      if (!this.isNew)
        headers.push({
          text: i18n.t("ReturnOrder.DetailFields.attachments"),
          align: "start",
          sortable: false,
          value: "attachments",
        });
      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("ReturnOrder.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("ReturnOrder.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("ReturnOrder.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    relationsHeaders: () => [
      {
        text: i18n.t("ReturnOrder.RelationFields.identify_name"),
        align: "center",
        sortable: false,
        value: "identify_name",
      },
      {
        text: i18n.t("ReturnOrder.RelationFields.identify_code"),
        align: "start",
        sortable: false,
        value: "identify_code",
      },
      {
        text: i18n.t("ReturnOrder.RelationFields.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("ReturnOrder.RelationFields.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
      {
        text: i18n.t("ReturnOrder.RelationFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    orderDetails() {
      let items = this.order_combine_materials.map((combineDetail) => {
        combineDetail.Description = combineDetail.ruler_name
        combineDetail.sum = combineDetail.price * combineDetail.apply_num;
        return combineDetail;
      });

      this.order_details
        .filter((detail) => (!this.savable || !detail.auto_flg) && detail.auto_flg != 3)
        .forEach((detail) => {
          detail.Description = i18n.t(
            this.accountSettings
              ? this.accountSettings.material_name_display_type == 3
                ? "Material.materialNameWithCodeAndStandard"
                : this.accountSettings.material_name_display_type == 2
                ? "Material.materialNameWithCode"
                : "Material.materialName"
              : "Material.materialName",
            [detail.material_code, detail.material_name, detail.standard_name]
          );
          items.push(detail);
        });
      return items;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "accountSettings", "accountUser", "userType"]),
  },

  mounted() {
    if (this.$route.path.startsWith("/return-order-new")) {
      this.mode = "new";
    } else {
      this.mode = this.$route.params.mode;
      if (this.mode)
        this.$router.replace("/return-orders/" + this.$route.params.id);
    }
  },

  data: () => ({
    panels: [0],
    tab: null,
    mode: "",
    shop: {},
    order: {},
    price_fix: 0,
    bill: {},
    addMaterial: null,
    materials: [],
    order_details: [],
    order_combine_materials: [],
    order_activities: [],
    order_relations: [],
    filter: "",
    memo_dialog: false,
    detail_memo_item: { memo: "" },
    dialogMaterialID: null,
    album: [],
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 10000000).length == 0 ||
        i18n.t("Material.imgsHint"),
    ],
    imgs_file: [],
    currentItem: {},
    dialogAttachments: false,
    selectOrderDialog: false,
    selectOrder: null,
    forOrder: [],
    forOrderFlg: false,
    returnable_details: [],
  }),

  methods: {
    getOrderFromAPI() {
      ReturnOrders.fetchOne(this.$route.params.id, { order_activity: 1, combine_material: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.order = response.data.return_order;
            this.album = response.data.return_order.order_img;

            if (this.order && this.order.order_combine_materials) {
              this.order.order_combine_materials.forEach((combine_detail) => {
                combine_detail.combineFlg = true;
                combine_detail.confirm_num = combine_detail.apply_num;
              });
              this.order_combine_materials = this.order.order_combine_materials
            }

            if (
              this.mode == "confirm" &&
              this.order &&
              this.order.order_details
            ) {
              this.order.order_details.forEach(
                (detail) => (detail.confirm_num = detail.apply_num)
                // 确认订单时默认填充核定数量
              );
            }

            if (this.order.relation_order_id) {
              this.forOrderFlg = true
            }

            this.order_activities = response.data.order_activities;
          }
        }.bind(this)
      );
      if (this.$permission.permissionAllow("ReturnOrders", "relations")) {
        ReturnOrders.fetchRelations(this.$route.params.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.order_relations = [];
              if (
                response.data.order.length ||
                Object.keys(response.data.order).length
              ) {
                this.order_relations.push(
                  Object.assign(
                    {
                      controller: "Orders",
                      identify: "orders",
                      identify_name: i18n.t("Order.ObjectName"),
                      identify_code: response.data.order.order_code,
                    },
                    response.data.order
                  )
                );
              }
              this.order_relations.push(
                Object.assign(
                  {
                    controller: "Receipt",
                    identify: "receipts",
                    identify_name: i18n.t("Bill.ObjectName"),
                    identify_code: response.data.bill.bill_code,
                  },
                  response.data.bill
                )
              );
              if (response.data.qacenter_question) {
                this.order_relations.push(
                  Object.assign(
                    {
                      controller: "Qacenter",
                      identify: "qacenter/question-detail",
                      identify_name: i18n.t("Complaint.ObjectName"),
                      identify_code:
                        response.data.qacenter_question.question_code,
                    },
                    response.data.qacenter_question
                  )
                );
              }
              if (response.data.psi_stock_order) {
                this.order_relations.push(
                  Object.assign(
                    {
                      controller: "stockOrderOut",
                      identify: "stock-order-out",
                      identify_name: i18n.t("ReturnOrder.ShopObjectName"),
                      identify_code:
                        response.data.psi_stock_order.stock_order_code,
                      creater_name:
                        response.data.return_order.shop.shop_user.name,
                    },
                    response.data.psi_stock_order
                  )
                );
              }
            }
          }.bind(this)
        );
      }
    },
    submitMethod() {
      if (this.isNew) return ReturnOrders.add(this.order);
    },
    async doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      // 检查一下图片上传的error，拒绝上传
      if (this.isNew) {
        if (this.$refs.imgs_file.hasError) {
          this.$store.dispatch("fullscreenLoadingStop");
          return;
        }
        //提交图片集
        var order_img = [];
        if (this.imgs_file && this.imgs_file.length > 0) {
          let response = await Files.imagesUpload(
            this.imgs_file,
            false,
            "images"
          );

          if (response.data.status.isOK()) {
            response.data.data.forEach((img) => order_img.push(img.img_name));
          }
        }

        this.order = Object.assign({}, this.order, { order_img: order_img });
        if (this.forOrderFlg) {
          this.order = Object.assign({}, this.order, {
            order_id: this.forOrder.id,
          });
        }
      } else if (!this.isNew) {
        this.submitUploadImg();
      }
      this.submitMethod().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.push("/return-orders");
            // this.$store.commit("refreshToDos", true);
          } else if (response.data.error.code == "ERR759") {
            //退货单切单失败
            this.mode = "view";
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    addOrderDetail(material, num) {
      if (num == 0) return;
      Materials.fetchOne(material.id, { shop_id: this.shop.id }).then(
        function (response) {
          if (response.data.status.isOK()) {
            material = response.data.material;
            var order_detail = {
              new: true,
              order_id: this.order.id,
              category_name: material.material_category.name,
              category_code: material.material_category.code,
              material_id: material.id,
              material_code: material.material_code,
              material_name: material.material_name,
              org_price: material.supply_price ? material.supply_price : 0,
              confirm_price: material.supply_price ? material.supply_price : 0,
              price: material.supply_price ? material.supply_price : 0,
              auto_flg: 0,
              memo: null,
              unit: material.supply_standard_detail.unit,
              standard_detail_id: material.supply_standard_detail_id,
              standard_name: material.standard.name,
              error_flg: 0,
              price_flg: 0,
              material: material,
            };
            if (!isNaN(Number(num))) {
              if (this.isNew) order_detail.apply_num = num;
              else if (this.mode == "confirm" || this.mode == "edit")
                order_detail.confirm_num = num;
            }
            this.order_details.push(order_detail);
          }
        }.bind(this)
      );
    },
    removeFromImages(i) {
      this.album.splice(i, 1);
      this.imgs_file.splice(i, 1);
    },
    async submitUploadImg() {
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.imgs_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }

      //提交图片集
      var order_img = [];
      if (this.imgs_file && this.imgs_file.length > 0) {
        let response = await Files.imagesUpload(
          this.imgs_file,
          false,
          "images"
        );

        if (response.data.status.isOK()) {
          response.data.data.forEach((img) => order_img.push(img.img_name));
          Orders.update({
            order_code: this.order.order_code,
            order_img: order_img,
          })
            .then(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            )
            .catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
        }
      }
    },
    async resetOrder() {
      this.shop = {
        id: this.userType == 0 ? this.accountUser.id : this.accountUser.shop_id
      };

      var today = new Date();
      today.setHours(0, 0, 0, 0);
      this.order = {
        shop_id: this.shop.id,
        status: 1,
        origin_flg: "002",
        created_id: this.accountUser.id,
        creater_name: this.accountUser.name,
        actual_date: this.$datetimeUtils.formatTime(new Date()),
        expect_date: null,
        order_details: [],
        order_combine_materials: []
      };
      this.selectShopDialog = false;
      this.selectShop = null;
      this.forOrder = [];
      this.forOrderFlg = false;
      this.returnable_details = [];
    }
  },

  watch: {
    $route(to, from) {
      this.selectOrderDialog = false;
      if (to.path.startsWith("/return-order-new")) {
        this.mode = "new";
        // 重新初始化界面
        this.panels = [0];
        this.tab = null;
        this.selectOrder = null;
        this.forOrder = [];
        this.forOrderFlg = false;
        this.returnable_details = [];
        this.shop = {};
        this.order = {};
        this.bill = {};
        this.addMaterial = null;
        this.order_details = [];
        this.order_combine_materials = [];
        this.order_activities = [];
        this.order_relations = [];
        this.filter = "";
      } else if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/return-orders/" + to.params.id);
      } else if (
        from.path.startsWith("/return-order-new") &&
        from.path != to.path
      ) {
        this.mode = "view"; // 从return-order-new退回时触发状态变化和数据重加载
      }
      // console.log('from', from);
      // console.log('to', to);
    },
    accountUser: {
      immediate:true,
      handler() {
        if (this.isNew && this.accountUser) {
          this.resetOrder()
          this.selectOrderDialog = true;
        }
      }
    },
    mode: {
      handler() {
        if (this.isNew && this.accountUser) {
          this.resetOrder()
          this.selectOrderDialog = true;
        }
        else if (this.$route.params.id) this.getOrderFromAPI();
      },
    },
    selectOrder: {
      immediate: true,
      handler() {
        this.order_details = [];
        this.order_combine_materials = [];
        this.order.order_details = this.order_details;
        this.order.order_combine_materials = this.order_combine_materials;
        if (this.selectOrder) {
          this.forOrder = this.selectOrder;
          this.forOrderFlg = true;
          ReturnOrders.getReturnableView(this.forOrder.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                if (response.data.returnable_combine_materials) {
                  response.data.returnable_combine_materials.forEach((combine) => {
                    let combine_detail = {
                      new: true,
                      combineFlg: true,
                      ruler_id: combine.ruler_id,
                      ruler_name: combine.ruler_name,
                      refundable_num: combine.refundable_num,
                      apply_num: combine.refundable_num,
                      price: combine.price ? combine.price : 0,
                      org_price: combine.org_price ? combine.org_price : 0,
                    };
                    this.order_combine_materials.push(combine_detail);
                  });
                  this.order.order_combine_materials = this.order_combine_materials;
                }
                if (response.data.returnable_details) {
                  response.data.returnable_details.forEach((detail) => {
                    let order_detail = {
                      new: true,
                      order_id: this.order.id,
                      category_name: detail.category_name,
                      category_code: detail.category_code,
                      material_id: detail.material_id,
                      material_code: detail.material_code,
                      material_name: detail.material_name,
                      org_price: detail.org_price ? detail.org_price : 0,
                      confirm_price: detail.confirm_price
                              ? detail.confirm_price
                              : 0,
                      price: detail.price ? detail.price : 0,
                      auto_flg: detail.auto_flg,
                      memo: null,
                      unit: detail.unit,
                      standard_detail_id: detail.standard_detail_id,
                      standard_name: detail.standard_name,
                      error_flg: 0,
                      price_flg: 0,
                      material: detail,
                      refundable_num: detail.refundable_num,
                      apply_num: detail.refundable_num
                    };
                    order_detail.material.id = order_detail.material_id
                    this.order_details.push(order_detail);
                  })
                  this.order.order_details = this.order_details;
                }
              }
            }.bind(this)
          );
          this.selectOrderDialog = false;
          this.selectOrder = null;
        }
      },
    },
    forOrderFlg: {
      handler() {
        if (!this.forOrderFlg) {
          this.selectOrder = null;
          this.forOrder = [];
          this.returnable_details = [];
          this.order_details = [];
          this.order.order_details = this.order_details;
          this.order_combine_materials = [];
          this.order.order_combine_materials = this.order_combine_materials;
        }
      },
    },
    order: {
      handler() {
        this.order_details =
          this.order && this.order.order_details
            ? this.order.order_details
            : [];
        this.price_fix = this.order ? this.order.price_fix : 0;
        this.shop = this.order && this.order.shop ? this.order.shop : this.shop;
        this.bill = this.order && this.order.bill ? this.order.bill : this.bill;
      },
    },
    order_details: {
      deep: true,
      handler() {
        var orderPrice = 0;
        var priceFix = 0;
        this.order_details.forEach((detail) => {
          var apply_num = detail.apply_num ? detail.apply_num : 0;
          var confirm_num = detail.confirm_num ? detail.confirm_num : 0;
          if (this.savable) {
            detail.fix_num = this.isNew // 新建时取申请量，其他时候取确认量加追加量
              ? Number(apply_num)
              : Number(confirm_num); //兼容添加新商品、确认商品数量、编辑追加商品数量的累计申请量计算
          } // 非编辑模式以接口返回为准，不作调整
          orderPrice += parseFloat(
            this.$numberFormatter.moneyFormat(
              parseFloat((detail.org_price * detail.fix_num).toFixed(4))
            )
          );
          detail.sum = parseFloat(
            this.$numberFormatter.moneyFormat(
              parseFloat((detail.price * detail.fix_num).toFixed(4))
            )
          );
          priceFix += detail.sum;

          //计算过期日期
          if (
            this.accountSettings &&
            this.accountSettings.product_date_setting &&
            detail.production_date &&
            !detail.expired_date
          ) {
            detail.expired_date = new Date(
              new Date(detail.production_date).getTime() +
                Number(detail.material.bestbefore) * 24 * 3600 * 1000
            )
              .toISOString()
              .substr(0, 10);
          }
        });
        priceFix = parseFloat(priceFix.toFixed(2));
        orderPrice = parseFloat(orderPrice.toFixed(2));
        this.order.order_price = orderPrice;
        this.order.price_fix = this.price_fix = priceFix;
        this.order.price_cut = parseFloat((orderPrice - priceFix).toFixed(2));
      },
    },
    addMaterial: {
      handler() {
        if (this.addMaterial && this.addMaterial.id) {
          this.addOrderDetail(this.addMaterial);
          this.addMaterial = {
            id: 0,
            material_code: "",
            material_name: "",
            standard_name: "",
          }; //消除显示
        }
      },
    },
    imgs_file: {
      deep: true,
      handler() {
        if (this.imgs_file.length) {
          if (this.imgs_file.length > 3) {
            this.$snackbar.error(i18n.t("Examine.DetailFields.hint"));
            this.album = [];
            this.imgs_file = [];
          } else {
            this.album = [];
            this.imgs_file.forEach((img) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.push(this.result);
              };
            });
          }
        } else {
          this.album = this.order.order_img ? this.order.order_img : [];
        }
      },
    },
  },
};
</script>
